<template>
  <nav class="toc-container" v-scrollspy="{offset: 80}">
    <span class="toc-heading">Contents</span>
    <ul class="nav">
      <li
        v-for="entry in entries"
        :key="entry.target">
        <i class="fa fa-circle"/>
        <a
          :href="'#' + entry.target"
          v-smooth-scroll="smoothScrollOptions"
          @click.prevent="trackClick(entry)">
          {{ entry.text }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import Vue from 'vue'
import vueSmoothScroll from '@/util/vue-smooth-scroll.directive'
Vue.use(vueSmoothScroll)

export default {
  name: 'PageTOC',
  props: {
    entries: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      smoothScrollOptions: { offset: -70, history: false }
    }
  },
  methods: {
    trackClick(entry) {
      this.$sendEvent('Clicked Curated Collection TOC', { toc_section: entry.text })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';

.toc-container {
  background: white;
  padding: 1em 1.5em 1.5em 1.5em;
}

.toc-heading {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 1.25em;
}

.nav {
  margin-top: 1em;
  margin-left: 0.5em;
  border-left: 1px solid #ccc;

  & > li {
    position: relative;
    padding: 0 0 0 1.5em;
    margin-bottom: 1.5em;
    font-size: 1.25em;

    &:last-child {
      margin-bottom: 0;
    }

    &.active {
      & > a {
        color: @link-color;
      }
      .fa {
        color: @link-color;
        opacity: 1;
      }
    }

    .fa {
      color: #ccc;
      position: absolute;
      font-size: 11px;
      top: 0.75em;
      left: -5px;
      transition: 0.3s opacity;
    }
    & > a {
      padding: 0;
      color: #333;
      font-weight: 500;

      &:focus,
      &:hover {
        background: transparent;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
